<template>
    <dg-field-container :label_span="label_span" :field_span="field_span" :field_mark="field_mark"
                     style="min-height: 200px;max-height: 200px">
        <template v-slot:label>
            <dg-label-field :label="label"></dg-label-field>
        </template>
        <template v-slot:field>
            <el-upload
                ref="avatar"
                class="avatar-uploader"
                :action="autoUploadPath"
                :show-file-list="false"
                :auto-upload="autoUpload"
                :on-change="onChange"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar" style="width: 100%; height: 200px">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <slot name="field_note"></slot>
            <div class="error-field-validate-message" v-if="validateMessage">
                {{validateMessage}}
            </div>
        </template>
    </dg-field-container>
</template>

<script>
    /*   unused Feature: autoload */
    import inputField from '../mixins/inputField';

    export default {
        mixins: [inputField],
        props: {
            autoUpload: {
                required: false,
                default: false
            },
            autoUploadPath: {
                required: false,
                default: ''
            },
            label: {
                required: true,
                type: String
            }

        },
        data() {
            return {
                imageUrl: '',
                binding: 'image'
            };
        },
        beforeMount() {
        },
        methods: {
            submitUpload() {
                this.$refs.avatar.submit();
            },
            handleAvatarSuccess(res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            onChange(file) {
                if (this.beforeAvatarUpload(file.raw)) {
                    this.imageUrl = URL.createObjectURL(file.raw);
                    this.field_value = file.raw;
                    W_LOGGER('this.field_value', this.field_value);
                    this.updateValue();
                }
            },
            beforeAvatarUpload(file) {
                if (this.autoUpload && this.autoUploadPath == '') {
                    this.$message.error('No Auto Upload Path Defined');
                    return false;
                }

                let allowedExt = ['image/jpeg', 'image/jpg', 'image/png'];
                const isJPG = allowedExt.indexOf(file.type) !== -1;
                const isLt2M = file.size / 1024 / 1024 < 2; // 2MB max file size

                if (!isJPG) {
                    this.$message.error('Avatar picture must be JPG, JPEG or PNG format!');
                }
                if (!isLt2M) {
                    this.$message.error('Avatar picture size can not exceed 2MB!');
                }
                return isJPG && isLt2M;
            }
        }
    }
</script>

<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px !important;
        text-align: center;
    }

</style>
